import { Colors, FlexBox, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import { classNames } from "react-select/src/utils";
import styled from "styled-components";

export const BackButtonContainer = styled(FlexBox).attrs({
    classNames: 'back-button'
})`
    color: ${Colors.galBlack47};
    flex-flow: row;
    width: 100%;
    transition: color 0.2s;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;

    span, svg {
        cursor: pointer;
    }

    svg path {
        fill: ${Colors.galBlack47};
        transition: fill 0.2s;
    }

    .inner-container {
        :hover {
            svg path {
                fill: ${p => p.theme.designerPage.slideHover };
                transition: fill 0.2s;
            }
            span {
                color: ${p => p.theme.designerPage.slideHover };
                transition: color 0.2s;
            }
        }
    }

    
    @media ${MEDIA.TABLET}{
        font-size: 15px;
        line-height: 20px;
    }

    @media ${MEDIA.MOBILE}{
        font-size: 13px;
        line-height: 16px;
    }

`;
import { Colors, FlexBox, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import { classNames } from "react-select/src/utils";
import styled from "styled-components";

export const BackButtonContainer = styled(FlexBox).attrs({
    classNames: 'back-button'
})`
    color: ${Colors.galBlack47};
    flex-flow: row;
    width: 100%;
    transition: color 0.2s;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 129.412% */
    letter-spacing: -0.34px;

    span, svg {
        cursor: pointer;
    }

    svg path {
        fill: ${Colors.galBlack47};
        transition: fill 0.2s;
    }

    .inner-container {
        :hover {
            svg path {
                fill: ${p => p.theme.designerPage.slideHover };
                transition: fill 0.2s;
            }
            span {
                color: ${p => p.theme.designerPage.slideHover };
                transition: color 0.2s;
            }
        }
    }

    
    @media ${MEDIA.TABLET}{
        font-size: 15px;
        line-height: 20px;
    }

    @media ${MEDIA.MOBILE}{
        font-size: 13px;
        line-height: 16px;
    }

`;
